var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.product_name.length < _vm.maxLength)?_c('h4',[_vm._v("\n    "+_vm._s(_vm.product_name)+"\n  ")]):_c('h4',{attrs:{"title":_vm.product_name}},[_vm._v("\n    "+_vm._s(_vm.product_name.substr(0, _vm.maxLength) + "...")+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }